import React from 'react'
import ContactForm from '../components/contactForm'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
    root: {},
    header: {
        fontSize: '3rem'
    },
    body: {
        fontSize: '1.5rem'
    }
})

const Contact = () => {
    const classes = useStyles()
    return (
        <div className="contact">
            <h1>How To Reach Us</h1>
            <div className="contentContainer contactContainer">
                <div className="contact__wrapper">
                    <h2>Contact Methods and Links</h2>
                    <p>
                        Here are all the ways you can contact us. Feel free to
                        call our office line, send us an email, or find us on
                        linked in. If you want you can even send us an email
                        straight from the contact box.
                    </p>
                    <div className="contact__info">
                        <div className="contact__emails">
                            <h3>Email</h3>
                            <ul>
                                <li>
                                    Kyle Willard -{' '}
                                    <a href="mailto:kyle@newevo.dev">
                                        kyle@newevo.dev
                                    </a>
                                </li>
                                <li>
                                    Jesse Medrano -{' '}
                                    <a href="mailto:jesse@newevo.dev">
                                        jesse@newevo.dev
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="contact__phone">
                            <h3>Phone</h3>
                            <ul>
                                <li>
                                    Office -{' '}
                                    <a href="tel:+‪5412246990">
                                        ‪(541) 224-6990
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="contact__social">
                            <h3>Social Media Links</h3>
                            <ul>
                                <li>
                                    <a href="https://www.facebook.com/New-Evolution-Digital-111914851152207">
                                        ‪Facebook
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/company/new-evolution-digital/">
                                        LinkedIn
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <h2>Request A Quote</h2>
                    <ContactForm />
                </div>
            </div>
        </div>
    )
}

{
    /* <div>
                    <Typography
                        className={classes.header}
                        variant="h5"
                        gutterBottom
                    >
                        Thank you for your feedback!
                    </Typography>
                    <Typography className={classes.body} variation="body1">
                        New Evolution Digital thrives off of feedback and ideas
                        in a creative way. If you have questions, comments, or
                        concerns please let us know so that we can address them.
                        If you are ready to set up an initial consultation feel
                        free to use the calendars below and we would be happy to
                        meet with you.
                    </Typography>
                </div> */
}
export default Contact
